export const BASENAME = '/'; // don't add '/' at end off BASENAME for breadcrumbs
export const BASE_URL = '/';
export const BASE_TITLE = ' | Kyan App';

//Configuracion de colores

export const CONFIG = {
  layout: 'vertical', // vertical, horizontal
  subLayout: '', // horizontal-2
  collapseMenu: false, // mini-menu
  layoutType: 'menu-light', // menu-dark, menu-light, dark
  headerBackColor: 'header-darkgreen', // header-blue, header-red, header-purple, header-info, header-green header-dark
  rtlLayout: false,
  navFixedLayout: true,
  headerFixedLayout: true,
  boxLayout: false,
  jwt: {
    secret: 'SECRET-KEY',
    timeout: '1 days'
  },
  // firebase: {
  //   apiKey: "AIzaSyCTblezrR-ElO94NYukenYG4ckLQLCQIY4",
  //   authDomain: "foxy-94c21.firebaseapp.com",
  //   projectId: "foxy-94c21",
  //   storageBucket: "foxy-94c21.appspot.com",
  //   messagingSenderId: "60314862479",
  //   appId: "1:60314862479:web:258b5af42b988416d741fa",
  //   measurementId: "G-1HPNCR23Z5"
  // },
  // auth0: {
  //   client_id: 'CkaKvwheIhIQkybjTEQwN7ikcdHObsPh',
  //   domain: 'dev-w0-vxep3.us.auth0.com'
  // }
};
